import { combineReducers } from '@reduxjs/toolkit';
import dashboard from "./dashboardSlice";

const dashboardReducer = combineReducers({
    dashboard
});

export default dashboardReducer;